export default "__VITE_ASSET__DUaIh$qF__"